/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React, { useRef, useState } from "react";
import styled from "styled-components";
import { format } from "date-fns";
import Text from "../Text";
import Flex from "../Flex";
import CalendarDatePicker from "./CalendarDatePicker";
import Anchor from "../Anchor";
import FormatDateTime from "../../formatters/FormatDateTime";

const Wrapper = styled.div`
  position: relative;
  width: max-content;
`;

const StartDatePicker = ({ date, label = "Start from", minDate, onChange }) => {
  const triggerRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [calendarPosition, setCalendarPosition] = useState('bottom');

  const handleOpen = () => {
    if (triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      setCalendarPosition(
        window.innerHeight - rect.bottom < 300 && rect.top > window.innerHeight - rect.bottom ? "top" : "bottom"
      );
    }
    setIsOpen(true);
  };

  const handleChange = (newDate) => {
    onChange?.(newDate);
    setIsOpen(false);
  };

  if (!date) return null;

  return (
    <Wrapper ref={triggerRef}>
      <Flex $gap="0.25rem" $align="baseline" $wrap="wrap">
        <Text size="small">{label}</Text>
        <Anchor underline="always" size="small" onClick={handleOpen}><FormatDateTime value={date} format={FormatDateTime.FORMAT.DATE} /></Anchor>
      </Flex>
      <CalendarDatePicker
        show={isOpen}
        position={calendarPosition}
        align={'left'}
        triggerRef={triggerRef}
        selectedDate={format(date, 'yyyy-MM-dd')}
        minDate={minDate}
        onChange={handleChange}
        onClose={() => setIsOpen(false)}
      />
    </Wrapper>
  );
};

export default StartDatePicker;